import { delayedPromise, howLongSince } from 'lib'
import type { Result } from 'generated/api'
import { UrlObject } from 'url'

const TIMEOUT = 30 // in seconds

export const pollForResults = async (id: string, startTime = Date.now()): Promise<Result> => {
	const { getResults } = await import('services/FionaAPI/Search/searchHelpers')
	const response = await getResults(id)
	const secondsElapsed = howLongSince(startTime)
	if (response.status === 'completed' || secondsElapsed > TIMEOUT) {
		return response
	} else {
		return delayedPromise(secondsElapsed > 10 ? 1000 : 500, (): Promise<Result> => {
			return pollForResults(id, startTime)
		})
	}
}

export const buildLoanSearchUrl = (loanPurpose?: string): UrlObject => {
	const query = { productType: 'loan' }
	if (loanPurpose) Object.assign(query, { loanPurpose })
	return { pathname: '/explore/loans', query }
}
